<div class="content">
  <h2 mat-dialog-title class="title">{{ whatsAppUserName }}'s Chat Messages</h2>
  <div class="message-window">
    <message-window [messages]="messages"></message-window>
  </div>
</div>
